function smsTabIsVisible(doc) {
  if (!doc) return true;
  if (doc.hidden === true || doc.visibilityState === 'hidden') return false;
  return true;
}

module.exports = {
  smsTabIsVisible,
};
